import type { ReactElement } from "react"

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined"
import { Button, Typography } from "@synapse-analytics/synapse-ui"

import type { TopSectionProps } from "./Interfaces"

import styles from "./TopSection.module.scss"

/**
 * Renders the top section of the sidebar, which includes the "New Model" button
 * and the project name.
 *
 * @param {TopSectionProps} props The component props.
 * @returns {ReactElement} The rendered component.
 */

export const TopSection = ({ buttonTitle, projectName, setOpenNewModelDialog }: TopSectionProps): ReactElement => {
  return (
    <div className={styles.sidebarTopSection}>
      <Typography variant="a" variantColor={2} className={styles.modelTitle}>
        {projectName}
      </Typography>
      <div className={styles.buttonContainer}>
        <Button
          variant="primary"
          size="small"
          autoCapitalize="on"
          fullWidth
          className={styles.addBtn}
          onClick={setOpenNewModelDialog.bind(null, true)}
          startIcon={
            <AddCircleOutlineOutlinedIcon
              sx={{
                width: "15px",
                height: "15px",
              }}
            />
          }
        >
          {buttonTitle}
        </Button>
      </div>
    </div>
  )
}
